import React from "react";
import ParkEnter from "../../ParkEnter";

const Screen28 = () => {
    return <ParkEnter />;
};

export default Screen28;
